import * as React from 'react';
import NotificationComponent from 'components/notification';
import Scanner from 'components/scanner';
import { Alert } from 'types/alert';
import { AlertModal } from 'components/alert';
import { EPC_SCAN_ACTION } from 'components/scanner/actions';
import { FullPage } from 'components/full-page/component';
import { Notification } from 'types/notification';
import { OperationGridView } from 'components/operation-grid/component';

import './styles.css';

export interface ConnectedProps {
  username: string;
  alerts: Alert[];
  notification: Notification | null;
  isManualInputHidden: boolean;
  isScannerEnabled: boolean;
}

export interface ActionProps {
  closeAlert?: (clientTransactionId: string, username: string) => void;
}

export type Props = ConnectedProps & ActionProps;

export function Main(props: Props) {
  return (
    <FullPage>
      {
        props.isScannerEnabled
          ? <Scanner scannerActionType={EPC_SCAN_ACTION} />
          : null
      }
      <OperationGridView />
      {
        props.alerts
          ? props.alerts.map((alert) => {
            return <AlertModal
              key={alert.item.clientTransactionId}
              alert={alert}
              close={(clientTransactionId: string) => {
                if (props.closeAlert) {
                  props.closeAlert(clientTransactionId, props.username);
                }
              }} />;
          })
          : null
      }
      {
        props.notification
          ? <NotificationComponent key={props.notification.id.toString()} notification={props.notification} />
          : null
      }
    </FullPage>
  );
}


// WEBPACK FOOTER //
// ./src/components/main/component.tsx